/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Carousel from "./pages/Carousel";
import Header from "./pages/header";
import Footer from "./pages/footer";
import carousel_1 from "../img/carousel_1.jpg";
import about_1 from "../img/about_1.jpg";
import about_2 from "../img/about_2.jpg";
import about_3 from "../img/about_3.jpg";
import about_4 from "../img/about_4.jpg";
import FAQSection from "./FAQSection";
import CareerTips from "./CareerTips";
import StatsSection from "./StatsSection";
import CallToAction from "./CallToAction";
import Companies from "./pages/Companies";

const Home = () => {
  const [processTab, setProcessTab] = useState("candidate");

  // --- Styles ---
  const cardStyle = { transition: "all 0.3s ease", cursor: "pointer" };
  const jobCardStyle = {
    boxShadow: "0 0 45px rgba(0, 0, 0, .08)",
    transition: ".5s",
  };
  const activeTabStyle = {
    backgroundColor: "#fb5d16",
    color: "#fff",
    border: "none",
  };
  const inactiveTabStyle = {
    backgroundColor: "#fff",
    color: "#666",
    border: "1px solid #ddd",
  };

  return (
    <>
      <Header path="/" />

      {/* --- 1. HERO SECTION --- */}
      <div className="container-fluid p-0">
        <div className="owl-carousel header-carousel position-relative">
          <div
            className="owl-carousel-item position-relative"
            style={{ backgroundColor: "#fb5d16", minHeight: "600px" }}
          >
            {" "}
            {/* Set background color and a minimum height */}
            <div
              className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center"
              // The background rgba overlay is removed as the main background is now solid color
            >
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-10 col-lg-8">
                    <h1 className="display-3 text-white animated slideInDown mb-4">
                      Find The Perfect Job That You Deserve
                    </h1>
                    <p className="fs-5 fw-bold text-white mb-4 pb-2">
                      Unlock your potential with Career Connect. We bridge the
                      gap between talent and opportunity with over 10,000 active
                      listings.
                    </p>
                    <a
                      href="/jobs"
                      className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft"
                    >
                      Search A Job
                    </a>
                    <a
                      href="/about"
                      className="btn btn-primary py-md-3 px-md-5 animated slideInRight"
                    >
                      Find A Talent
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- 2. CATEGORIES SECTION --- */}
      <div className="container-fluid py-5">
        <div className="container">
          <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            Explore By Category
          </h1>
          <div className="row g-4">
            {[
              { icon: "fa-mail-bulk", title: "Marketing", vacancy: "12" },
              { icon: "fa-headset", title: "Customer Service", vacancy: "45" },
              { icon: "fa-user-tie", title: "Human Resource", vacancy: "20" },
              { icon: "fa-tasks", title: "Project Management", vacancy: "15" },
              { icon: "fa-chart-line", title: "Business Dev", vacancy: "34" },
              { icon: "fa-hands-helping", title: "Sales", vacancy: "60" },
              { icon: "fa-book-reader", title: "Education", vacancy: "22" },
              { icon: "fa-drafting-compass", title: "Design", vacancy: "08" },
            ].map((item, index) => (
              <div
                className="col-lg-3 col-sm-6 wow fadeInUp"
                data-wow-delay="0.1s"
                key={index}
              >
                <a
                  className="cat-item rounded p-4 border d-block text-decoration-none shadow-sm bg-white"
                  href={`/jobs?category=${item.title.toLowerCase()}`}
                  style={cardStyle}
                >
                  <i className={`fa ${item.icon} fa-3x text-primary mb-4`} />
                  <h6 className="mb-3 text-dark">{item.title}</h6>
                  <p className="mb-0 text-muted">{item.vacancy} Vacancy</p>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* --- 3. ABOUT SECTION --- */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.1s">
              <div className="row g-0 about-bg rounded overflow-hidden">
                <div className="col-6 text-start">
                  <img
                    className="img-fluid w-100"
                    src={about_1}
                    alt="About 1"
                  />
                </div>
                <div className="col-6 text-start">
                  <img
                    className="img-fluid"
                    src={about_2}
                    alt="About 2"
                    style={{ width: "85%", marginTop: "15%" }}
                  />
                </div>
                <div className="col-6 text-end">
                  <img
                    className="img-fluid"
                    src={about_3}
                    alt="About 3"
                    style={{ width: "85%" }}
                  />
                </div>
                <div className="col-6 text-end">
                  <img
                    className="img-fluid w-100"
                    src={about_4}
                    alt="About 4"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-6 wow fadeIn" data-wow-delay="0.5s">
              <h1 className="mb-4">
                Find Your Next Dream Job With AI-Driven Precision
              </h1>

              <p className="mb-4">
                Stop searching endlessly. In an era of information overload,
                finding the right fit can feel impossible. That’s where we come
                in. Our platform utilizes
                <strong> proprietary AI-driven algorithms</strong> to cut
                through the noise, connecting top-tier talent with world-class
                opportunities in milliseconds.
              </p>
              <p className="mb-4 text-muted">
                We don't just match keywords; we align visions. Whether you are
                a disruptive startup hunting for a rare "unicorn" to lead your
                tech team, or a seasoned professional seeking a role that values
                your worth, we bridge the gap with unmatched efficiency,
                transparency, and precision.
              </p>

              {/* Feature Grid: 2x2 Layout */}
              <div className="row g-3 mb-4">
                {/* Feature 1 */}
                <div className="col-sm-6">
                  <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                    <i className="fa fa-check fa-2x text-primary flex-shrink-0 me-3" />
                    <div>
                      <h6 className="mb-1">Smart Matching</h6>
                      <small className="text-muted">
                        AI-based skill analysis.
                      </small>
                    </div>
                  </div>
                </div>

                {/* Feature 2 */}
                <div className="col-sm-6">
                  <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                    <i className="fa fa-user-check fa-2x text-primary flex-shrink-0 me-3" />
                    <div>
                      <h6 className="mb-1">Verified Recruiters</h6>
                      <small className="text-muted">
                        100% trusted companies.
                      </small>
                    </div>
                  </div>
                </div>

                {/* Feature 3 */}
                <div className="col-sm-6">
                  <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                    <i className="fa fa-drafting-compass fa-2x text-primary flex-shrink-0 me-3" />
                    <div>
                      <h6 className="mb-1">Career Roadmap</h6>
                      <small className="text-muted">
                        Growth path visualization.
                      </small>
                    </div>
                  </div>
                </div>

                {/* Feature 4 */}
                <div className="col-sm-6">
                  <div className="d-flex align-items-center border-start border-5 border-primary px-3">
                    <i className="fa fa-headset fa-2x text-primary flex-shrink-0 me-3" />
                    <div>
                      <h6 className="mb-1">24/7 Support</h6>
                      <small className="text-muted">
                        Dedicated expert help.
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-3 bg-primary p-3">
                <a className="btn btn-outline-light py-3 px-5 " href="/about">
                  Read More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- 4. STATS SECTION --- */}
      <div className="container-fluid py-5 bg-primary hero-header mb-5">
        <div className="container my-5 py-5 px-lg-5">
          <div className="row g-5 py-5">
            <div className="col-12 text-center  mb-4">
              <h2 className="text-white animated slideInDown">
                Trusted By Thousands
              </h2>
              <hr
                className="bg-white mx-auto"
                style={{ width: "100px", height: "3px" }}
              />
            </div>

            {/* Item 1 */}
            <div
              className="col-md-6 col-lg-3 text-center wow fadeIn"
              data-wow-delay="0.1s"
            >
              {/* ADDED BOX WRAPPER HERE */}
              <div className="p-4 rounded border border-white bg-white bg-opacity-10 shadow-sm">
                <i className="fa fa-check fa-3x  mb-3"></i>
                <h1 className=" mb-2" data-toggle="counter-up">
                  1234
                </h1>
                <p className=" mb-0">Daily Live Jobs</p>
              </div>
            </div>

            {/* Item 2 */}
            <div
              className="col-md-6 col-lg-3 text-center wow fadeIn"
              data-wow-delay="0.3s"
            >
              <div className="p-4 rounded border border-white bg-white bg-opacity-10 shadow-sm">
                <i className="fa fa-users-cog fa-3x  mb-3"></i>
                <h1 className=" mb-2" data-toggle="counter-up">
                  123
                </h1>
                <p className=" mb-0">Companies</p>
              </div>
            </div>

            {/* Item 3 */}
            <div
              className="col-md-6 col-lg-3 text-center wow fadeIn"
              data-wow-delay="0.5s"
            >
              <div className="p-4 rounded border border-white bg-white bg-opacity-10 shadow-sm">
                <i className="fa fa-users fa-3x  mb-3"></i>
                <h1 className=" mb-2" data-toggle="counter-up">
                  1234
                </h1>
                <p className=" mb-0">Talents Hired</p>
              </div>
            </div>

            {/* Item 4 */}
            <div
              className="col-md-6 col-lg-3 text-center wow fadeIn"
              data-wow-delay="0.7s"
            >
              <div className="p-4 rounded border border-white bg-white bg-opacity-10 shadow-sm">
                <i className="fa fa-tasks fa-3x  mb-3"></i>
                <h1 className=" mb-2" data-toggle="counter-up">
                  1234
                </h1>
                <p className=" mb-0">Resumes Added</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- 5. PROCESS SECTION (Tabs) --- */}
      <div className="container-fluid py-5">
        <div className="container">
          <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            Our Application Process
          </h1>
          <div className="row justify-content-center mb-5">
            <div className="col-lg-6 d-flex justify-content-center">
              <button
                className="btn px-5 py-3 rounded-pill me-2 fw-bold"
                onClick={() => setProcessTab("candidate")}
                style={
                  processTab === "candidate" ? activeTabStyle : inactiveTabStyle
                }
              >
                For Candidates
              </button>
              <button
                className="btn px-5 py-3 rounded-pill fw-bold"
                onClick={() => setProcessTab("employer")}
                style={
                  processTab === "employer" ? activeTabStyle : inactiveTabStyle
                }
              >
                For Employers
              </button>
            </div>
          </div>
          <div className="row g-4 justify-content-center">
            {processTab === "candidate" ? (
              <>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-user-plus fa-2x text-white mb-3"></i>
                    <h5 className="text-white">1. Register Profile</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-file-upload fa-2x text-white mb-3"></i>
                    <h5 className="text-white">2. Upload Resume</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-search fa-2x text-white mb-3"></i>
                    <h5 className="text-white">3. Apply for Jobs</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-check-circle fa-2x text-white mb-3"></i>
                    <h5 className="text-white">4. Get Hired</h5>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-building fa-2x text-white mb-3"></i>
                    <h5 className="text-white">1. Create Account</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-bullhorn fa-2x text-white mb-3"></i>
                    <h5 className="text-white">2. Post A Job</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-filter fa-2x text-white mb-3"></i>
                    <h5 className="text-white">3. Screen Resumes</h5>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6 text-center wow fadeInUp">
                  <div className="process-item p-4 shadow rounded bg-primary border">
                    <i className="fa fa-handshake fa-2x text-white mb-3"></i>
                    <h5 className="text-white">4. Interview & Hire</h5>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* --- 7. NEW: CAREER TIPS & NEWS (SEO GOLD MINE) --- */}
      <CareerTips />
      <StatsSection />
      <CallToAction />

      {/* --- 8. NEW: FAQ SECTION (SEO & KEYWORDS) --- */}

      {/* --- 10. NEW: BROWSE BY LOCATION (Local SEO) --- */}
      {/* <div className="container-fluid py-5">
        <div className="container">
          <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            Jobs by Location
          </h1>
          <div className="row g-4">
            {[
              {
                city: "New York",
                jobs: "1,200",
                img: '',
              },
              {
                city: "San Francisco",
                jobs: "850",
                img: "https://via.placeholder.com/600x400?text=SF",
              },
              {
                city: "London, UK",
                jobs: "940",
                img: "https://via.placeholder.com/600x400?text=London",
              },
              {
                city: "Bangalore",
                jobs: "2,100",
                img: "https://via.placeholder.com/600x400?text=Bangalore",
              },
              {
                city: "Berlin",
                jobs: "400",
                img: "https://via.placeholder.com/600x400?text=Berlin",
              },
              {
                city: "Remote",
                jobs: "5,340",
                img: "https://via.placeholder.com/600x400?text=Remote",
              },
            ].map((loc, index) => (
              <div
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay={`0.${index + 1}s`}
                key={index}
              >
                <a
                  className="d-block position-relative overflow-hidden text-decoration-none rounded shadow-sm"
                  href={`/jobs/location/${loc.city.toLowerCase()}`}
                >
                  <img
                    className="img-fluid"
                    src={loc.img}
                    alt={`Jobs in ${loc.city}`}
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />
                  <div
                    className="bg-white text-center position-absolute bottom-0 end-0 py-2 px-3"
                    style={{ margin: "1px" }}
                  >
                    <h6 className="m-0">{loc.city}</h6>
                    <small className="text-primary">{loc.jobs} Openings</small>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      {/* --- 11. NEW: TOP COMPANIES (Authority/Trust) --- */}
      {/* <Companies /> */}

      {/* --- 12. NEW: POPULAR SEARCHES (Long-tail Keywords) --- */}
      <div className="container-fluid py-5 bg-light">
        <div className="container">
          <h4 className="mb-4">Popular Searches</h4>
          <div className="d-flex flex-wrap gap-2">
            {[
              "Remote Python Jobs",
              "Part-time Data Entry",
              "Freelance Graphic Design",
              "ReactJS Developer salary",
              "Marketing Manager jobs NYC",
              "Entry level HR jobs",
              "Work from home Customer Support",
              "Cyber Security Analyst",
              "Full Stack Developer",
              "Internships for freshers",
              "Night shift jobs",
              "Startup jobs",
            ].map((tag, index) => (
              <a
                href={`/jobs?q=${tag}`}
                key={index}
                className="btn btn-outline-secondary btn-sm rounded-pill bg-white"
              >
                {tag}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* <Carousel /> */}
      {/* --- 9. TESTIMONIALS --- */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <h1 className="text-center mb-5">Our Clients Say!!!</h1>
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="testimonial-item bg-light rounded p-4 mb-4 border">
                <i className="fa fa-quote-left fa-2x text-primary mb-3"></i>
                <p>
                  "Career Connect helped me land my dream job in just 2 weeks.
                  The process was seamless."
                </p>
                <div className="d-flex align-items-center">
                  <img
                    className="img-fluid flex-shrink-0 rounded"
                    src={about_1}
                    style={{ width: "50px", height: "50px" }}
                    alt="client"
                  />
                  <div className="ps-3">
                    <h5 className="mb-1">Sarah Nelson</h5>
                    <small>Web Designer</small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="testimonial-item bg-light rounded p-4 mb-4 border">
                <i className="fa fa-quote-left fa-2x text-primary mb-3"></i>
                <p>
                  "As a recruiter, I found excellent talent here. The filtering
                  options saved me a lot of time."
                </p>
                <div className="d-flex align-items-center">
                  <img
                    className="img-fluid flex-shrink-0 rounded"
                    src={about_3}
                    style={{ width: "50px", height: "50px" }}
                    alt="client"
                  />
                  <div className="ps-3">
                    <h5 className="mb-1">John Doe</h5>
                    <small>HR Manager</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FAQSection />

      <Footer />
      <a href="#" className="btn btn-lg bg-primary btn-lg-square back-to-top text-white">
        <i className="bi bi-arrow-up" />
      </a>
    </>
  );
};

export default Home;
